/**
 * Tìm kiếm "kết quả mới nhất thắng": debounce theo từ khóa và bỏ kết quả trả về trễ của lần gõ cũ.
 * Tách khỏi component để kiểm thử không cần DOM.
 */
export interface LatestSearchOptions<T> {
  search: (query: string) => Promise<T[]>
  /** Chờ bao lâu sau phím cuối mới gọi server. Từ khóa rỗng gọi ngay. */
  debounceMs: number
  onResult: (items: T[]) => void
  onError: (err: unknown) => void
  onBusy: (busy: boolean) => void
}

export function createLatestSearch<T>(opts: LatestSearchOptions<T>) {
  let seq = 0
  let timer: ReturnType<typeof setTimeout> | null = null

  return {
    run(query: string): void {
      const mine = ++seq
      if (timer) clearTimeout(timer)
      timer = setTimeout(
        async () => {
          opts.onBusy(true)
          try {
            const items = await opts.search(query)
            if (mine === seq) opts.onResult(items)
          } catch (err) {
            if (mine === seq) opts.onError(err)
          } finally {
            if (mine === seq) opts.onBusy(false)
          }
        },
        query ? opts.debounceMs : 0,
      )
    },
    cancel(): void {
      seq++
      if (timer) clearTimeout(timer)
      timer = null
    },
  }
}
